import Elyon81 from '../../../Media/BSD/Elyon L/Elyon 8.webp'
import Elyon82 from '../../../Media/BSD/Elyon L/Elyon 8.webp'





const Elyon8images =[
Elyon81,Elyon82
]

export default Elyon8images;